export default "__VITE_ASSET__D3kBJoD4__"